import BuilderModel from "./builderModel";
import ObjectModel from "../objectModel";

export default class ObjectModelBuilderModel extends BuilderModel {
  rootModel: ObjectModel;
  objectModel: ObjectModel;
  except = ['objectModel', 'createEmbeddedObject', 'notifications'];
}
